import React from 'react';

import './ClosingBand.scss';
import * as Util from '../../Util';

const ClosingBand = ({ isAuthed, history }) => {
  const label = isAuthed ? 'Go to Dashboard' : 'Start with 3 free opt-outs';
  const path = isAuthed ? '/dashboard' : '/start/step1';

  const handleClick = () => {
    if (Util.isProduction()) {
      if (window.amplitude) {
        window.amplitude
          .getInstance()
          .logEvent('Closing CTA Clicked', { authed: !!isAuthed });
      }
      if (window.mixpanel) {
        window.mixpanel.track('Closing CTA Clicked', { authed: !!isAuthed });
      }
    }
    history.push(path);
  };

  return (
    <section className="ClosingBand">
      <div className="ClosingBand__inner">
        <h2 className="ClosingBand__heading">
          Your mailbox — and the planet — will thank you.
        </h2>

        <p className="ClosingBand__body">
          Join thousands of people who've reclaimed their peace of mind and
          helped save <strong>20,166+ trees</strong>.
        </p>

        <button
          type="button"
          className="ClosingBand__cta"
          onClick={handleClick}
        >
          {label}
        </button>

        <p className="ClosingBand__trust">
          30-day money-back guarantee · Cancel anytime · Less than a coffee a
          month
        </p>
      </div>
    </section>
  );
};

export default ClosingBand;
